import { useEffect, useState } from "react"
import { Data, Modal, ModalId, useUIState } from "../../../../../features/ui"
import { ContactForm } from "./contactForm"

type Props = {
    contactData?: Data
    onSubmit: (data: Data) => void
}

export const ContactFormModal = (props: Props) => {
    const { contactData, onSubmit } = props
    const [key, setKey] = useState(0)
    const { openedModal } = useUIState()

    useEffect(() => setKey(key + 1), [openedModal])
    
    return (
        <Modal
            modalId={ModalId.CONTACT_FORM}
            title="Agregar Contacto"
            actions={[]}
            widthSize="m"
        >
            <ContactForm
                key={key}
                contactData={contactData}
                onSubmit={onSubmit}
            />
        </Modal>
    )
}
